import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { painPoints } from '../data/content';
const chain = ['What to look at', 'What to decide', 'What to do', 'What to check'];
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-230" data-mp="26wbmkwz2u6ks">
      <div className="mx-auto max-w-5xl" data-id="element-231" data-mp="2bvy2xfa7c2xt">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-232" data-mp="1xxre0on8ddaa">
          👉 Do any of these sound familiar?
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] text-brand-900/70" data-id="element-233" data-mp="220o0iqfw5tji">
          If you answer YES to even one… this system was designed for you.
        </p>

        <ul className="mt-9 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="1szpszy68v3w6">
          {painPoints.map(point => <li key={point.title} className="flex h-full flex-col rounded-2xl border border-brand-100 bg-cream p-5" data-id="element-235" data-mp="3iee4zyaxajto">
              <span className="text-2xl" aria-hidden="true" data-id="element-236" data-mp="1yzvirhfuantx">
                {point.emoji}
              </span>
              <h3 className="mt-3 text-[16px] font-bold leading-snug text-ink" data-id="element-237" data-mp="1u0iy93cfxsui">{point.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-brand-900/70" data-id="element-238" data-mp="27rxgv92frs11">{point.text}</p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl bg-brand-800 px-5 py-9 sm:px-10 sm:py-12" data-id="element-239" data-mp="23thw7bttuvqs">
          <h3 className="text-center font-display text-[24px] font-bold leading-tight text-white sm:text-3xl" data-id="element-240" data-mp="1g2ceer4bttdu">
            And it shouldn’t feel this complicated.
          </h3>
          <div className="mx-auto mt-5 max-w-2xl space-y-3 text-center text-[15px] leading-relaxed text-brand-100" data-id="element-241" data-mp="1p3k6grg91xzh">
            <p data-id="element-242" data-mp="1k1usb2xqd476">Because the problem isn’t necessarily your hand skills.</p>
            <p data-id="element-243" data-mp="30gmjjcj545ew">
              The problem may be that no one ever taught you a{' '}
              <strong className="font-bold text-white" data-id="element-244" data-mp="2vj2vjkwn4e9r">visual system</strong> for understanding what
              to look for and what decision to make at each stage of a resin veneer.
            </p>
            <p data-id="element-245" data-mp="1y3q9e3og39it">You don’t need another 10-hour course. You need to know:</p>
          </div>

          <ol className="mx-auto mt-7 flex max-w-3xl flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:justify-center" data-id="element-246" data-mp="225bkpklbzfqw">
            {chain.map((step, index) => <React.Fragment key={step} data-id="element-247" data-mp="272k41oi7tptq" data-mpi={index}>
                <li className="flex-1 rounded-xl bg-white/10 px-3 py-3 text-center text-[12.5px] font-extrabold uppercase tracking-[0.08em] text-white ring-1 ring-white/15 sm:text-[11.5px]" data-id="element-248" data-mp="1afowyjo5b8y4">
                  {step}
                </li>
                {index < chain.length - 1 && <ArrowRightIcon className="mx-auto h-4 w-4 shrink-0 rotate-90 text-brand-300 sm:rotate-0" aria-hidden="true" data-id="element-249" data-mp="1o6lpkai2nq56" />}
              </React.Fragment>)}
          </ol>

          <div className="mx-auto mt-9 max-w-xl" data-id="element-250" data-mp="vneohjwzjwsp">
            <CTAButton label="I want the visual system" data-id="element-251" data-mp="o571gray470o" />
            <p className="mt-3 text-center text-[12.5px] font-medium text-brand-200" data-id="element-252" data-mp="j75jk9p9adqs">
              Instant access · $27 USD one-time · 7-day guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}